
import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Box, Button, IconButton } from '@material-ui/core';
import Checkbox from '../checkbox'
import { Link, useHistory } from "react-router-dom";
import Customlink from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography';
import SnackBarCustom from '../users/snackbar';
import { baseApiUrl } from '../dataProvider/sails';
import HeaderSortable from '../common/header-sortable';
import { useTranslate } from 'react-admin';
import bin from '../assets/icons/primary-blue-bin.png';
import { useLocation } from "react-router-dom";
import { Clear, DeleteOutline } from '@material-ui/icons';
import { StyledButton } from '../common/table';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.primary.main,
        borderBottom: 'solid 5px ' + theme.palette.background.default,
        fontWeight: 'inherit'
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 600,
    },
    tableCell: {
        borderBottom: 'solid 5px ' + theme.palette.background.default
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
        color: 'white'
    },
    tableSortLabel: {
        fontFamily: 'UniviaPro',
        fontSize: ' 13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: ' 0.13px',
        color: '#ffffff',
        '&:hover': {
            color: '#ffffff'
        },
        '&:focus': {
            color: '#ffffff'
        },
    },
    textTableName: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#237fc2',
    },
    textTable: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#4f5064',
        width: 280,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    },
    textTableSmaller: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#4f5064',
        width: 50,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    },
    borderCluster: {
        borderRadius: '10px',
        border: 'solid 1px #e0f0f2',
        backgroundColor: ' #fafefe',
    },
    textCluster: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: ' 0.36px',
        color: '#6cb5b8',
        textAlign: 'center',
        padding: '8px',
    },
    textEdit: {
        fontFamily: 'UniviaPro',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    },
    borderDelete: {
        borderRadius: '12px',
        backgroundColor: '#e5f1f8',
    },

    TitleUser: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    textbtnCreate: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    },
    large: {
        border: '1px solid #ddd',
        borderRadius: 2,
        padding: 2,
        width: 50,
        height: 40,
        '&:hover': {
            boxShadow: '0 0 2px 1px rgba(0, 140, 186, 0.5)'
        }
    },
}));

const headCells = [
    { id: 'checkmark', numeric: false, disablePadding: false, label: '' },
    { id: 'logo', numeric: false, disablePadding: true, label: 'Logo' },
    { id: 'number', numeric: true, disablePadding: false, label: 'Number' },
    { id: 'type', numeric: false, disablePadding: false, label: 'Type' },
    { id: 'name', numeric: false, disablePadding: true, label: 'Name' },
    { id: 'internalName', numeric: false, disablePadding: false, label: 'Internal-Name' },
    { id: 'epgId', numeric: false, disablePadding: false, label: 'Epg-id' }
];

function EnhancedTableHead(props) {
    const { classes, order, setOrder, handleCheckMark, data, checked, isHidden } = props;

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <StyledTableCell
                        className={classes.tableSortLabel}
                        key={'cell-' + headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                    >
                        {
                            headCell.label !== '' ?
                                (
                                    headCell.label === 'Logo' ?
                                        headCell.label : <HeaderSortable
                                            title={headCell.label}
                                            field={headCell.id}
                                            order={order}
                                            setOrder={setOrder}
                                        />
                                )
                                :
                                headCell.id === 'checkmark' ?
                                    <Box hidden={isHidden}>
                                        <Checkbox checked={checked.length === data.length} color='primary' onChange={(event) => handleCheckMark(event, -1, true)} />
                                    </Box>
                                    :
                                    <Box />

                        }
                    </StyledTableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

function CustomTable({ data, getList, onDelete, buttonHidden, total, onClear, checked, handleCheckMark, error }) {
    const classes = useStyles();
    const translate = useTranslate();
    const location = useLocation();
    const history = useHistory();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = useState({ field: 'name', order: 'ASC' });
    const [openEdit, setOpenEdit] = useState(false);

    const handleChangePage = (event, newPage) => {
        const pagination = { page: newPage + 1, perPage: rowsPerPage };
        getList(order, pagination);
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        const pagination = { page: 1, perPage: event.target.value };
        getList(order, pagination);
    };

    const handleRequestSort = (nextSort) => {
        setPage(0);
        setOrder(nextSort);

        const pagination = { page: 1, perPage: rowsPerPage };
        getList(nextSort, pagination);
    };

    const handleCloseEdit = () => {
        setOpenEdit(!openEdit);
    };



    return (

        <Paper className={classes.root}>
            {
                location.state !== undefined && location.state.user !== undefined &&
                <SnackBarCustom
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }}
                    message="User Deleted !"
                    open={location.state.open === "true" ? !openEdit : openEdit}
                    handleClose={() => handleCloseEdit()} />
            }

            <TableContainer className={classes.container}>
                <Table aria-label="sticky table">
                    {
                        checked.length > 0 ? (
                            <TableHead style={{ maxHeight: 70 }}>
                                <TableRow style={{ maxHeight: 70 }}>
                                    <TableCell style={{ backgroundColor: '#56657f', padding: '17px' }}>
                                        <Checkbox checked={checked.length === data.length} color='primary' onChange={(event) => handleCheckMark(event, -1, true)} />
                                    </TableCell>
                                    <TableCell style={{ backgroundColor: '#56657f', padding: '16px', height: '14%' }}>
                                        <StyledButton
                                            onClick={onDelete}
                                            variant='text'
                                            startIcon={<DeleteOutline />}
                                            style={{ left: -50, width: 68 }}
                                        >{translate(`pos.common.delete`)}</StyledButton>
                                    </TableCell>
                                    <TableCell style={{ backgroundColor: '#56657f', padding: '16px', height: '14%', width: 70 }}></TableCell>
                                    <TableCell style={{ backgroundColor: '#56657f', padding: '16px', height: '14%' }}></TableCell>
                                    <TableCell style={{ backgroundColor: '#56657f', padding: '16px', height: '14%' }}></TableCell>
                                    <TableCell style={{ backgroundColor: '#56657f', padding: '16px', height: '14%' }}></TableCell>
                                    <TableCell style={{ backgroundColor: '#56657f', padding: '8px 0', height: '14%' }} align='right'>
                                        <StyledButton
                                            onClick={onClear}
                                            variant='text'
                                            startIcon={<Clear />}
                                        >{checked.length} {checked.length > 1 ? translate('pos.categories.filesSelected') : translate('pos.categories.fileSelected')}</StyledButton>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                        ) :
                            < EnhancedTableHead isHidden={buttonHidden} checked={checked} data={data} handleCheckMark={handleCheckMark} classes={classes} order={order} setOrder={handleRequestSort} />
                    }
                    {
                        error > 0 ?
                            <TableBody>
                                {
                                    data.map((item, index) => (
                                        buttonHidden ? <TableRow key={'table-row-' + index} tabIndex={-1} >
                                            <TableCell key={index + '-0'} width={60} height={48} className={classes.tableCell} />
                                            <TableCell key={index + '-1'} width={100} className={classes.tableCell}>
                                                {
                                                    item.logo && <img src={baseApiUrl + '/media/' + JSON.parse(item.logo).fd} className={classes.large} />
                                                }
                                            </TableCell>
                                            <TableCell key={index + '-2'} className={classes.tableCell}><Typography className={classes.textTableSmaller}>{item.number}</Typography></TableCell>
                                            <TableCell key={index + '-3'} className={classes.tableCell}><Typography className={classes.textTableSmaller} >{item.type}</Typography></TableCell>
                                            <TableCell key={index + '-4'} className={classes.tableCell}><Typography className={classes.textTable}>{item.name}</Typography></TableCell>
                                            <TableCell key={index + '-5'} className={classes.tableCell}><Typography className={classes.textTable}>{item.internalName}</Typography></TableCell>
                                            <TableCell key={index + '-6'} className={classes.tableCell}><Typography className={classes.textTable}>{item.epgId}</Typography></TableCell>

                                        </TableRow> :
                                            <TableRow key={'table-row-' + index} tabIndex={-1} style={{ cursor: 'pointer' }} onClick={() => { history.push("/channel/" + item.id) }}>
                                                <TableCell key={index + '-0'} style={{ width: 60, height: 48 }} className={classes.tableCell}>
                                                    <Checkbox disabled={buttonHidden} checked={item.checked ? true : false} onClick={e => e.stopPropagation()} onChange={(event) => handleCheckMark(event, index)} color='primary' />
                                                </TableCell>
                                                <TableCell key={index + '-1'} style={{ width: 100 }} className={classes.tableCell}>
                                                    {
                                                        item.logo && <img src={baseApiUrl + '/media/' + JSON.parse(item.logo).fd} className={classes.large} />
                                                    }
                                                </TableCell>
                                                <TableCell key={index + '-2'} style={{ width: 70 }} className={classes.tableCell}><Typography className={classes.textTableSmaller}>{item.number}</Typography></TableCell>
                                                <TableCell key={index + '-3'} className={classes.tableCell}><Typography className={classes.textTableSmaller} >{item.type}</Typography></TableCell>
                                                <TableCell key={index + '-4'} className={classes.tableCell}><Typography className={classes.textTable}>{item.name}</Typography></TableCell>
                                                <TableCell key={index + '-5'} className={classes.tableCell}><Typography className={classes.textTable}>{item.internalName}</Typography></TableCell>
                                                <TableCell key={index + '-6'} className={classes.tableCell}><Typography className={classes.textTable}>{item.epgId}</Typography></TableCell>

                                            </TableRow>
                                    ))
                                }

                            </TableBody> :
                            <TableBody>
                                <TableRow>
                                    <TableCell className={classes.tableCell}></TableCell>
                                    <TableCell className={classes.tableCell}></TableCell>
                                    <TableCell className={classes.tableCell}></TableCell>
                                    <TableCell className={classes.tableCell}></TableCell>
                                    <TableCell className={classes.tableCell}> <Typography className={classes.textTable}>{translate(`pos.channels.noData`)}</Typography></TableCell>
                                    <TableCell className={classes.tableCell}></TableCell>
                                    <TableCell className={classes.tableCell}></TableCell>
                                </TableRow>
                            </TableBody>
                    }
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={total}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </Paper>
    );
}

export default CustomTable;
